import {delay, asBase64, env, isDevEnv, isProdEnv} from "./runtimeHelpers";
export {delay, asBase64, env, isDevEnv, isProdEnv};
/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import { v4 as uuid } from 'uuid';
// import {create} from "vue3-modal-dialogs"

// import linkifyHtml from 'linkify-html';
// import moment from "moment";
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min'
import {plainToClass} from "class-transformer";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import dayjs from "dayjs";
import CommonObject from "@shared/CommonObject.js";
import {array} from "@qwoach/cytoscape/src/is";

// var abbrs = {
// 	EST : 'Eastern Standard Time',
// 	EDT : 'Eastern Daylight Time',
// 	CST : 'Central Standard Time',
// 	CDT : 'Central Daylight Time',
// 	MST : 'Mountain Standard Time',
// 	MDT : 'Mountain Daylight Time',
// 	PST : 'Pacific Standard Time',
// 	PDT : 'Pacific Daylight Time',
// };

let zoneName = function (moment) {
	var abbr = moment.zoneAbbr();
	console.log("zoneAbbr = ", abbr)
	// abbreviations clash with each other so it's not a reliable way to show names. Like CST refers to 3 different timezones: central/cuba/china
	let zoneName //= abbreviations[abbr] ? abbreviations[abbr].name : null
	zoneName = zoneName || moment.tz();
	// if(zoneName.indexOf("/") > 0){
	// 	let arr = zoneName.split("/")
	// 	zoneName = arr[arr.length - 1]
	// }
	if(zoneName.indexOf("Time") < 0){
		zoneName += " Time"
	}
	return zoneName
};

export const appName = process.env.VUE_APP_NAME || "Qwoach";

export const ProgressEnum = Object.freeze({
	DONT_SHOW: "DONT_SHOW",
	BLOCKING: "BLOCKING",
	DATA_LOADING: "DATA_LOADING",
	NOT_BLOCKING: "NOT_BLOCKING",
})

export const ViewModeEnum = Object.freeze({
	EDIT: "EDIT",
	ADD: "ADD",
	VIEW: "VIEW",
	ANSWER: "ANSWER",
	DELETE: "DELETE",
	DEMO: "DEMO"
})

export function pluralize(unit, count) {
	// console.log("helpers.pluralize: unit = ", unit, ", count = ", count)
	if (!unit) return "";
	// Simple pluralization: add 's' if count !== 1 and unit doesn't already end with 's'
	return (count == 1 || unit.endsWith("s")) ? unit : `${unit}s`;
}

export async function openNewWindowWhenReady(loadingUrl, prepareUrlCallback) {
	const newWindow = window.open(loadingUrl, "_blank")
	if (!newWindow) return "blocked"

	try {
		const destinationUrl = await prepareUrlCallback()
		if (!destinationUrl) {
			newWindow.close()
			return "cancelled"
		}
		if (newWindow.closed) return "closed"

		newWindow.location.replace(destinationUrl)
		return "opened"
	} catch (error) {
		if (!newWindow.closed) newWindow.close()
		throw error
	}
}

export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult
  if (removedIndex === null && addedIndex === null) return arr

	console.log("applyDrag: arr = ", arr, ", dragResult = ", dragResult)
  const result = [...arr]
  let itemToAdd = payload

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0]
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd)
  }

  return result
}

export const getSlotChildrenText = (children) => children.map(node => {
	if (!node.children || typeof node.children === 'string') return node.children || ''
	else if (Array.isArray(node.children)) return getSlotChildrenText(node.children)
	else if (node.children.default) return getSlotChildrenText(node.children.default())
}).join('')

export function ellipsisMiddle(text, maxLength) {
	text = text || ""
	if (text.length > maxLength) {
		let lengthStart = maxLength * 2/3 - 3
		let lengthEnd = maxLength *1/3
		return text.substring(0, lengthStart) + '...' + text.substring(text.length - lengthEnd, text.length);
	}
	return text;
}

export const printContent = () => {
	// let printContainerSelector = ".printable-content"
	// let content = document.querySelector(printContainerSelector)
	// let printContainer = getPrintContainer()
	// if(content){
	// 	printContainer.append(content.cloneNode(true))
	// }
	// document.body.prepend(printContainer)
	window.print()
	// document.body.removeChild(printContainer)
}

function getPrintContainer(){
	let printContainer = document.querySelector(".print-container-root")
	if(!printContainer){
		printContainer = document.createElement('div');
		printContainer.classList.add("print-container-root")
	}
	return printContainer
}


export const generateItems = (count, creator) => {
  const result = []
  for (let i = 0; i < count; i++) {
    result.push(creator(i))
  }
  return result
}

export function isObject(object) {
	return object !== null && typeof object === 'object'
}
export function isFunction(object) {
	return object !== null && typeof object === 'function'
}

export function stringContainsAny(str, array){
	if(typeof str !== "string" || !Array.isArray(array)){
		return false
	}
	return array.some(item => str.includes(item))
}

export function isFingerPointerDevice(object) {
	return !matchMedia('(pointer:fine)').matches
}
export function isOverflown(element) {
	return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

export function capitalizeFirstLetter(string) {
	if(string){
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	return string
}

export function generateLink(name, params = {}, query = {}, extraQuery) {
	let param = asBase64(JSON.stringify({name, params, query}))
	let urlStr = `${process.env.VUE_APP_DOMAIN}/app/lnk?p=${param}`

	if(extraQuery){
		let keyValueArray = Object.keys(extraQuery).map(key => `${key}=${extraQuery[key]}`)
		urlStr = [urlStr, ...keyValueArray].join("&")
	}
	return urlStr
}

export const retryFn = (intervalMs, maxAttempts, fn) => {
	let stopFn
	let promise = new Promise((resolve, reject) => {
		let attempts = 0;
		stopFn = setInterval(() => {
			let res = fn()
			if(res){
				clearInterval(stopFn)
				resolve(res)
			}
			attempts++;
			if (attempts >= maxAttempts) {
				clearInterval(stopFn)
				reject(new Error("max attempts reached"))
			}
		}, intervalMs)
	})
	return {
		promise,
		stop: () => {
			clearInterval(stopFn)
		}
	}
}
export function getCurrentDomain() {
	return process.env.VUE_APP_DOMAIN
}
export function getCurrentRemoteDomain() {
	return process.env.VUE_APP_DOMAIN_REMOTE || getCurrentDomain()
}
export function getApiDomain() {
	return process.env.VUE_APP_DOMAIN_API || process.env.VUE_APP_DOMAIN
}

export function stringToNumber(value) {
	if(value === null || value === undefined || value === ""){
		return value;
	}
	let num = parseFloat(value);
	if(isNaN(num)){
		return value;
	}
	return num;
}

export function sanitizeNumberInput(value) {
	return String(value ?? "").replace(/[^0-9.,-]/g, "")
}

export function jsonParseSecure(str, fallback = {}){
	try {
		return JSON.parse(str)
	} catch (error) {
		return fallback
	}
}

export function cloneRawJSON(rawJSON){
	if(!rawJSON){
		return null
	}
	return jsonParseSecure(JSON.stringify(rawJSON), null)
}

export function shadeColor(color, percent) {
	console.log("shadeColor: color = ", color)

	var R = parseInt(color.substring(1,3),16);
	var G = parseInt(color.substring(3,5),16);
	var B = parseInt(color.substring(5,7),16);

	console.log("shadeColor: ", `rgb1 = ${R}, ${G}, ${B}`)

	R = parseInt(R * (100 + percent) / 100);
	G = parseInt(G * (100 + percent) / 100);
	B = parseInt(B * (100 + percent) / 100);

	console.log("shadeColor: ", `rgb2 = ${R}, ${G}, ${B}`)
	R = (R<255)?R:255;
	G = (G<255)?G:255;
	B = (B<255)?B:255;
	console.log("shadeColor: ", `rgb3 = ${R}, ${G}, ${B}`)

	// R = Math.round(R / 10) * 10
	// G = Math.round(G / 10) * 10
	// B = Math.round(B / 10) * 10
	console.log("shadeColor: ", `rgb4 = ${R}, ${G}, ${B}`)

	var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
	var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
	var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));
	console.log("shadeColor: ", `rgb5 = ${RR}, ${GG}, ${BB}`)

	return "#"+RR+GG+BB;
}

// export function shadeColor(c, p){
// 	var i=parseInt,r=Math.round,[a,b,c,d]=c.split(","),P=p<0,t=P?0:255*p,P=P?1+p:1-p;
// 	return"rgb"+(d?"a(":"(")+r(i(a[3]=="a"?a.slice(5):a.slice(4))*P+t)+","+r(i(b)*P+t)+","+r(i(c)*P+t)+(d?","+d:")");
// }


export function hexToHSL(H, brightness) {
	// Convert hex to RGB first
	let r = 0, g = 0, b = 0;
	if (H.length == 4) {
		r = "0x" + H[1] + H[1];
		g = "0x" + H[2] + H[2];
		b = "0x" + H[3] + H[3];
	} else if (H.length == 7) {
		r = "0x" + H[1] + H[2];
		g = "0x" + H[3] + H[4];
		b = "0x" + H[5] + H[6];
	}
	// Then to HSL
	r /= 255;
	g /= 255;
	b /= 255;
	let cmin = Math.min(r,g,b),
		cmax = Math.max(r,g,b),
		delta = cmax - cmin,
		h = 0,
		s = 0,
		l = 0;

	if (delta == 0)
		h = 0;
	else if (cmax == r)
		h = ((g - b) / delta) % 6;
	else if (cmax == g)
		h = (b - r) / delta + 2;
	else
		h = (r - g) / delta + 4;

	h = Math.round(h * 60);

	if (h < 0)
		h += 360;

	l = (cmax + cmin) / 2;
	s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
	s = +(s * 100).toFixed(1);
	l = +(l * 100).toFixed(1);

	return {h, s, l}

	// return "hsl(" + h + "," + s + "%," + (l + brightness) + "%)";
}

export function hslObjToString({h, s, l}){
	return `hsl(${h}, ${s}%, ${l}%)`;
}



export const progressUIHandler = (context, promise, showProgress = ProgressEnum.NOT_BLOCKING, message = null) => {
	console.log("progressUIHandler: context = ", context)
	console.log("progressUIHandler: showProgress = ", showProgress)
	switch (showProgress){
		case ProgressEnum.BLOCKING:
			context.showProgressBlocking(message)
			break;
		case ProgressEnum.NOT_BLOCKING:
			context.showProgressNonBlocking()
			break;
		case ProgressEnum.DATA_LOADING:
			context.showProgressDataLoading()
			break;
	}
	return promise.then((result) => {
		context.hideProgress()
		return result;
	}).catch((error) => {
		context.hideProgressFail()
		logError(error)
		context.$message({
			type: 'error',
			message: error
		});
		throw error;
	})

};

export function groupBy(array, {key, groupMapper = (item) => item, defaultGroupName = "Ungrouped"} = {}) {
	const result = {};
	for (const item of array) {
		let group = item[key] || defaultGroupName;
		group = groupMapper(group)
		if (!result[group]) result[group] = [];
		result[group].push(item);
	}
	return result;
}

export function logEnhancedDataFn(data){
	if(isFunction(window.gtag())){
		window.gtag('set', 'user_data', data)
	}
}


export function uuidv4() {
	return uuid()
	// return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
	// 	(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	// )
}


export function isLinkValid(link){
	let res = /^[a-z0-9_-]*$/.test(link)
	console.log("isLinkValid: link = ", link, ", res = ", res)
	return res
}

export function formatTime(timeStr){
	console.log("formatTime: timeStr = ", timeStr)
	timeStr = timeStr.toLowerCase().replace(/[^0-9ap]/g, '');

	let ampm = 'am'
	if (timeStr.indexOf('p') >= 0){
		ampm = 'pm'
	}

	timeStr = timeStr.replace(/[ap]/g, '');

	if(timeStr.length == 3){
		timeStr = "0" + timeStr
	}
	let hourSubstr = timeStr.substring(0, 2)
	let minSubstr = timeStr.substring(2, 4)
	let hour = pad(Math.max(0, Math.min(12, hourSubstr)), 2)
	let minute = pad(Math.max(0, Math.min(59, minSubstr)), 2)

	let res = hour + ':' + minute + ' ' + ampm

	console.log(`formatTime: ${timeStr}, hourSubstr = ${hourSubstr}, minSubstr = ${minSubstr}`)
	return res;
}

export function pad(num, size){ return ('000000000' + num).substr(-size); }



export function numbersFromString(str){
	// var regex = /[+-]?\d+\.*\d+/g;
	const regex = /[+-]?\d+(\.\d+)?/g;
	const matches = str.match(regex);
	return matches ? matches.map(Number) : [];
}

Promise.prototype.delay = function(t) {
	return this.then(function(v) {
		return delay(t, v);
	});
}

export function validateEmail(email) {
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export function isValidHttpUrl(string) {
	let url;
	try {
		url = new URL(string);
	} catch (_) {
		return false;
	}
	return url.protocol === "http:" || url.protocol === "https:";
}


export function formValidatorMessage(message){
	return formTriggerValidatorMessage(message)
}
export function formTriggerValidatorMessage(message){
	return formTriggerRequired(message)
}

export function formTriggerEmail(options = {}){
	return formTriggerValidator(emailValidatorFn, options)
}

export function validatorNonEmpty(value){
	console.log("validatorNonEmpty: value = ", value)
	if(value){
		return
	}
	return false
}

export function positiveNumberValidatorFn(value, options = {}){
	console.log("positiveNumberValidator: value = ", value)
	if (!value || isNaN(value) || value < 1) {
		return options.message || "Please provide a valid positive number"
	}
}
export function formTriggerPositiveNumber(message){
	return formTriggerRequired(undefined, positiveNumberValidatorFn, {message})
}
export function formTriggerMessage(message, validator){
	return formTriggerRequired(message, validator)
}
export function formTriggerNumber(message, validator){
	return formTriggerRequired(message, validator, {type: "number"})
}
export function formTriggerRequired(message, validator, options = {}){
	return {
		type: options.type,
		required: true,
		whitespace: false,
		message,
		validator: validator ? formValidator(validator, options) : undefined,
		trigger: 'validate'
	}
}

export function formTriggerValidator(asyncValidator, options = {}){
	return {
		required: options.required ?? true,
		whitespace: false,
		validator: formValidator(asyncValidator, options),
		trigger: 'validate'
	}
}

//DEPRECATED. Use formTriggerEmail(options) instead
export function emailFormValidatorFn(options = {}){
	return formValidator(emailValidatorFn, options)
}
export function emailValidatorFn(value, opts = {}){
	console.log("formEmailValidator: value = ", value, ", opts = ", opts)
	let {callback, options = {}} = opts
	let {isRequired = true} = options
	let errorMsg
	if(isRequired || value) {
		if (!value || !value.trim().length) {
			errorMsg = "Please provide email"
		} else if (!validateEmail(value.trim())) {
			errorMsg = "Seems like there is a typo in this email. Please double check it."
		}
	}
	if(callback){
		callback(errorMsg);
	} else {
		return errorMsg
	}
}

export async function formEmailValidatorPromise(value, options = {}){
	let {rule, source, options: opt} = options
	let errorMsg = emailValidatorFn(value, {rule, source, options: opt})
	if(errorMsg){
		throw errorMsg
	}
}

export function formValidatorInitials() {
	return formValidator(validatorInitialsFn())
}
export function validatorInitialsFn() {
	return (value) => {
		if(!value) return "Please provide client's initials";
		// if(value.length > 3) return "Client's initials should not exceed 3 characters";
	}
}

export function formValidator(validator = () => {}, optionsCustom = {}){
	return async (rule, value, callback, source, options = {}) => {
		try{
			options = {...options, ...optionsCustom}//we spread optionsCustom here too for compatibility with old code
			console.log("formValidator: pre res = ", value, ", rule = ", rule, ", source = ", source, ", options = ", options)
			let res = await validator(value, {rule, value, source, options, ...optionsCustom})
			console.log("formValidator: res = ", res)
			if(res === true){
				callback()
			} else {
				callback(res)
			}
		} catch (error){
			callback(error)
		}
	}
}


export function enumerateDaysBetweenDates(startDate, endDate) {
	let dates = [];

	let currDate = moment(startDate).startOf('day');
	let lastDate = moment(endDate).startOf('day');

	do{
		dates.push(currDate.clone().toDate());
	} while(currDate.add(1, 'days').diff(lastDate) <= 0)

	// console.log("dates = ", dates, ", startDate = ", startDate, ", endDate = ", endDate)
	return dates;
}

export function timestampFormatted(timestampMs, format = "MMM DD, YYYY"){
	return moment(timestampMs).format(format)
}

export function copyObject(clazz, obj){
	return classToClass(obj);
}

export function userTimezone() {
	return moment.tz.guess(true);
}

export function userTimezoneAbbreviation(timezone) {
	let zone = moment().tz(timezone || userTimezone()).zoneAbbr()
	// console.log("zone names = ", moment.tz.names())
	return zone
}
export function userTimezoneName(timezone) {
	// return moment().tz(timezone || userTimezone()).format('z');
	// return userTimezone()
	let zone = zoneName(moment().tz(timezone || userTimezone()))
	return zone
}

export function fromBase64(base64String = ""){
	if(base64String){
		return decodeURIComponent(atob(base64String))
	}
	return base64String
}


export function getStyle(el,styleProp)
{
	var x = document.getElementById(el);
	let y

	if (window.getComputedStyle)
	{
		y = document.defaultView.getComputedStyle(x,null).getPropertyValue(styleProp);
	}
	if (!y && x.currentStyle)
	{
		y = x.currentStyle[styleProp];
	}

	return y;
}



export function isEmpty(value){
	return value == null || value === "" || value.length === 0

}

export async function validateTags(text, {validTags = [], requiredTags = []}, errorCallback = () => {}){

	console.log("validateTags = ", ...arguments)

	let tagTokens = text.match(/{{([^{]*)}}/g)

	if(!tagTokens){
		return true
	}

	let invalidTags = []
	let missingRequiredTags = []

	let requiredTagsAnswers = {}
	requiredTags.forEach(tag => requiredTagsAnswers[tag.value] = false)

	if(tagTokens && tagTokens.length){
		for(let tagToken of tagTokens){
			let index = validTags.findIndex((tag) => tag.value === tagToken)
			if(index < 0){
				invalidTags.push(tagToken)
			}
			for(let requiredTag of requiredTags){
				if(requiredTag.value === tagToken){
					requiredTagsAnswers[tagToken] = true
				}
			}
		}
	}

	Object.keys(requiredTagsAnswers).forEach(key => {
		let isPresent = requiredTagsAnswers[key]
		if(!isPresent){
			missingRequiredTags.push(key)
		}
	})

	console.log("validateTags: tagTokens = ", tagTokens, ", invalidTags = ", invalidTags, ", missingRequiredTags = ", missingRequiredTags, ", requiredTagsAnswers = ", requiredTagsAnswers)

	if(invalidTags.length > 0 || missingRequiredTags.length > 0){
		await errorCallback(invalidTags, missingRequiredTags)
		return false
	}

	return true
}

export function fixTags(text){
	return text.replace(/{{([^{]*)}}/g, match => {
		let matchOriginal = match
		match = match.replace("<em>", "_")
		match = match.replace("</em>", "_")
		match = match.replace("&lt;em&gt;", "_")
		match = match.replace("&lt;/em&gt;", "_")
		if(match !== matchOriginal){
			console.error("preprocessBody has invalid symbols in tags that were force fixed: ", matchOriginal, ", text = ", text)
		}
		return match
	})
}

// export function logError(error){
// 	console.error(error)
// 	try{
// 		// need to move it outside utils since we now using modeil in server which depends on helpers and it created redundant dependencies
// 		// Vue.config.globalProperties.$server.logError(error)
// 	} catch (e) {
// 		console.error(e)
// 	}
// }


export const EMPTY_FUNCTION = () => {}
export const EMPTY_FUNCTION_OBJECT = () => ({})
export const EMPTY_FUNCTION_ARRAY = () => []
export const EMPTY_FUNCTION_ITEM = (item) => item

export function addUnique(array, element, equalsPredicate = _ => false) {
	let res = !array.find(item => equalsPredicate(item))
	if(res){
		array.push(element)
	}
	return res
}

export function humanFileSize(bytes, si) {
	if(bytes < 0){
		return "-"
	}
	var thresh = si ? 1000 : 1024;
	if(bytes < thresh) return bytes + ' B';
	var units = si ? ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'] : ['kB','MB','GB','TB','PB','EB','ZB','YB']
	var u = -1;
	do {
		bytes /= thresh;
		++u;
	} while(bytes >= thresh);
	return bytes.toFixed(0)+' '+units[u];
}

export function docToData(doc, clazz){
	let data = clazz ? plainToClass(clazz, doc.data()) : doc.data()
	return data;
}
export function docsToData(res, clazz){
	let data = res.docs.map(doc => doc.data())[0]
	let obj = data ? plainToClass(clazz, data) : null
	return obj;
}
export function docsToDataArray(res, clazz){
	let data = res.docs.map(doc => docToData(doc, clazz))
	return data;
}

export function isScripExist(id) {
	return document.getElementById(id)
}

export async function addScript(src, scriptId){
	return new Promise((resolve, reject) => {
		if(!scriptId){
			scriptId = btoa(src).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
		}
		if (document.getElementById(scriptId)) {
			console.log('script already loaded: ', src)
			return resolve()
		}
		var script = document.createElement( 'script' );
		script.setAttribute( 'src', src );
		script.setAttribute( 'id', scriptId );
		script.async = true;
		script.addEventListener('load', () => resolve(src));
		script.addEventListener('error', reject);
		document.head.appendChild(script);
	})
}



export function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}
export function newNumberedName(originalName, increaseBy) {
	let split = originalName.split(" ")
	let lastVar = split.pop();
	let name = split.join(" ");

	let baseNumber = 1;
	if(isNumeric(lastVar)){
		baseNumber = parseInt(lastVar)
	} else {
		name += " " + lastVar
 	}
	console.log(`newNumberedName: originalName = ${originalName}, split = ${split}, lastVar = ${lastVar}, isNumeric(lastVar) = ${isNumeric(lastVar)}, increaseBy = ${increaseBy}, baseNumber before = ${baseNumber}`)
	baseNumber += increaseBy

	let newName = name + " " + baseNumber
	return newName
}

export function waitFor(condition, maxRetry, retryDelay){
	return new Promise((resolve, reject) => {
		waitForInternal(condition, maxRetry, retryDelay, 1, resolve, reject)
	})
}
function waitForInternal(condition, maxRetry = 999999999999, retryDelay = 100, attemptNumber = 0, resolve, reject){
	if(condition()){
		resolve()
		return
	}
	if(attemptNumber > maxRetry){
		reject(new Error("max retry reached"))
		return
	}
	console.log("waitForInternal step " + attemptNumber)
	setTimeout(_ => {
		waitForInternal(condition, maxRetry, retryDelay, attemptNumber + 1, resolve, reject)
	}, retryDelay)
}

export function arraysEqual(a, b) {
	if (a === b) return true;
	if (a == null || b == null) return false;
	if (a.length != b.length) return false;
	for (let i = 0; i < a.length; ++i) {
		let left = a[i]
		let right = b[i]
		if(left !== right || (left.equals && !left.equals(right))) return false
	}
	return true;
}

export function findParentComponent(component, componentName){
	var parent = component.$parent || component.$root;
	var name = parent.$options.componentName;

	while (parent && (!name || name !== componentName)) {
		parent = parent.$parent;

		if (parent) {
			name = parent.$options.componentName;
		}
	}
	return parent
}

export function removeElementsByClass(className){
	let elements = document.getElementsByClassName(className);
	while(elements.length > 0){
		elements[0].parentNode.removeChild(elements[0]);
	}
}

//TODO won't work on server sid
export const APP_TYPE = process.env.VUE_APP_TYPE || exports.APP_TYPE || "QWOACH"
export const isAppTheraLogik = APP_TYPE === "THERALOGIK"

console.log("helpers.js AppType = ", APP_TYPE, ", isAppTheraLogik = ", isAppTheraLogik, ", isDevEnv = ", isDevEnv, ", isProdEnv = ", isProdEnv)

export function findChildComponentRecursively(thisComp, targetComp, level = 0){
	console.log("findChildComponentRecursively new level: thisComp = ", thisComp.$options.name, ", level = ", level, ", thisComp.$children = ", thisComp.$children.map(child => child.$options.name))
	for(let child of thisComp.$children){
		console.log("findChildComponentRecursively: child = ", child.$options.name)
		if(checkExtendsComponent(child, targetComp)){
			return child
		}
		let childComp = findChildComponentRecursively(child, targetComp, level + 1)
		if(childComp){
			return childComp
		}
	}
	return null
}

export function checkExtendsComponent(thisComp, targetComp) {
	// console.log("isExtendsComponent: thisComp.$options.name = ", thisComp.$options.name, ", targetComp.name = ", targetComp.name)
	// let i = 0
	// while (thisComp && i < 20) {
	// 	console.log("checkExtendsComponent: thisComp = ", thisComp, ", targetComp = ", targetComp)
	// 	if(thisComp.$options.name === targetComp.name){
	// 		return thisComp
	// 	}
	// 	thisComp = thisComp.$parent
	// 	i++
	// }
	// // console.log("isExtendsComponent: false")
	// return false;
	// console.log("isExtendsComponent: thisComp.$options.name = ", thisComp.$options.name, ", targetComp.name = ", targetComp.name)
	if(thisComp.$options.name === targetComp.name){
		return thisComp
	}
	let extendsObj = thisComp.$options.extends
	while (extendsObj) {
		// console.log("isExtendsComponent: extendsObj = ", extendsObj)
		if (extendsObj.name === targetComp.name) {
			// console.log("isExtendsComponent: true")
			return true;
		}
		extendsObj = extendsObj.extends;
	}
	// console.log("isExtendsComponent: false")
	return false;
}

export function getParentByTypeRecursive(thisComp, targetComp) {
	console.log("getParentByTypeRecursive: targetComp = ", targetComp.name)
	let curComponent = thisComp
	while (curComponent) {
		console.log("getParentByTypeRecursive: curComponent = ", curComponent.name)
		if(checkExtendsComponent(curComponent, targetComp)){
			return curComponent
		}
		curComponent = curComponent.$parent
	}
	return null;
}

export function uniqueBy(a, key) {
	let seen = new Set();
	return a.filter(item => {
		let k = item ? key(item) : item;
		let res = seen.has(k) ? false : seen.add(k);
		// console.log("onValueChanged1 uniqueBy: k = ", k, ", res = ", res, ", seen = ", seen)
		return res
	});
}

export function isIterable(obj) {
	if (obj == null) {
		return false;
	}
	return typeof obj[Symbol.iterator] === 'function';
}

export function stripHtmlTags(htmlString){
	let doc = new DOMParser().parseFromString(htmlString, 'text/html');
	return doc.body.textContent || "";
}

export function ellipsisString( str, n, useWordBoundary ){
	// console.log("ellipsisString: ", str)
	// str = str.split(/\n/)[0] //split by newline and take the first line only
	if (!str || str.length <= n) { return str; }
	const subString = str.substr(0, n-1); // the original check
	let lastIndex = subString.lastIndexOf(" ")
	if(lastIndex <= 0){
		lastIndex = n-1
	}
	return (useWordBoundary
		? subString.substr(0, lastIndex)
		: subString) + "...";
}

export function ellipsisStringMiddle( str, n, useWordBoundary ){
	if (!str || str.length <= n) { return str; }
	let l = Math.ceil(n / 2)
	let r = n - l
	// return str.substr(0, l) + '...' + str.substr(str.length - r, str.length);
	//rewrite to use a non deprecated version of subst
	return str.slice(0, l) + '...' + str.slice(-r)

}

export const IMAGE_EXTENSIONS = Object.freeze([
	"jpg", "jpeg", "png", "webp", "gif", "svg", "avif", "heic", "heif", "tif", "tiff", "bmp"
]);

export function daysDifference(dateMs) {
	return dayjs().startOf("day").diff(dayjs(dateMs).startOf("day"), "day")
}

export function daysDifferenceFormatted(dateMs, options = {}){
	let {capitalize, maxDays = 30, format = "MMM DD, YYYY", datePrefix = "", intervalPrefixFuture = "in"} = options
	let dateDayJs = dayjs(dateMs).startOf("day")
	let dateNowDayJs = dayjs().startOf("day")

	let cap = capitalize ? (val) => capitalizeFirstLetter(val) : (val) => val

	if(dateNowDayJs.isSame(dateDayJs, 'day')){
		return cap("today")
	}
	if(dateNowDayJs.add(-1, "day").isSame(dateDayJs, 'day')){
		return cap("yesterday")
	}
	if(dateNowDayJs.add(1, "day").isSame(dateDayJs, 'day')){
		return cap("tomorrow")
	}
	let daysDiff = daysDifference(dateMs)
	// console.log("daysDiff = ", daysDiff)
	// if(daysDiff === 0){
	// 	return "today"
	// }
	// if(daysDiff === -1){
	// 	return "tomorrow"
	// }
	// if(daysDiff === 1){
	// 	return "yesterday"
	// }

	if(maxDays > 0 && Math.abs(daysDiff) > maxDays){
		if(datePrefix){
			datePrefix = cap(datePrefix.trim() + " ")
		}
		return datePrefix + dateDayJs.format(format)
	}

	if(daysDiff > 0){
		// if(daysDiff === 1){daysDiff = 2}
		return daysDiff + " days ago"
	}

	// if(daysDiff === -1){daysDiff = -2}
	daysDiff = Math.abs(daysDiff)
	let s = daysDiff === 1 ? '' : 's'
	return cap(`${intervalPrefixFuture} ${daysDiff} day${s}`)

}

export function insertSubstringAtPosition(sourceStr, strToFind, indexToInsert, stringToInsert){
	let regExp = new RegExp(strToFind)
	let result = sourceStr.replace(regExp, match => {
		return match.slice(0, indexToInsert) + stringToInsert + match.slice(indexToInsert)
	})
	return result
}

export function firstLastNameFromFullName(fullName) {
	if (!fullName || typeof fullName !== "string") return "";

	fullName.split(",")[0].trim() //In case they add their title at the end, like "Alex McTeacher, PhD"

	// Normalize whitespace and trim
	let s = fullName.trim().replace(/\s+/g, " ");

	// Known prefixes (normalized to lowercase, dots ignored)
	const prefixes = new Set([
		"mr","mrs","ms","miss","mx","dr","prof","sir","dame","lord","lady",
		"rev","reverend","fr","father","br","bro","sr","sister","rabbi","imam",
		"sheikh","shaikh","shaik","pastor","bishop","archbishop","cardinal",
		"pres","president","chancellor","principal",
		"col","capt","cpt","cmdr","lt","lt col","lt-col","lt col","sgt","gen","adm",
		"hon","amb","sen","rep","gov","ofc"
	]);

	// Split into tokens
	let parts = s.split(" ").filter(Boolean);

	// Remove leading prefixes (supports chained prefixes and 2-word variants like "Lt Col")
	while (parts.length) {
		const head = parts[0].toLowerCase().replace(/\./g, "");
		const two = parts.length >= 2
			? (parts[0] + " " + parts[1]).toLowerCase().replace(/\./g, "")
			: "";

		if (prefixes.has(two)) {
			parts.shift(); parts.shift();
			continue;
		}
		if (prefixes.has(head)) {
			parts.shift();
			continue;
		}
		break;
	}

	if (!parts.length) return {firstName: "", lastName: ""};

	// Take the first token as the first name
	let first = parts[0];
	let last = parts.length > 1 ? parts.slice(1).join(" ") : "";

	// Strip surrounding quotes and trailing punctuation
	first = first.replace(/^["'‘’“”]+|["'‘’“”]+$/g, "").replace(/[,]+$/g, "");
	last = last.replace(/^["'‘’“”]+|["'‘’“”]+$/g, "").replace(/[,]+$/g, "");

	const capWord = (w) =>
		w.split(" ").map(seg => seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase()).join(" ");

	return {
		firstName: capWord(first),
		lastName: capWord(last),
	};
}


export const setIntervalWithDelay = (callback, interval, delay = 0) => {
	let descriptor = {}
	descriptor.timeoutId = setTimeout(() => {
		if(!descriptor.timeoutId){
			return
		}
		descriptor.timeoutId = null
		callback()
		descriptor.intervalId = setInterval(callback, interval)
	}, delay)
	return descriptor
}

export const clearIntervalWithDelay = (descriptor) => {
	if(!isObject(descriptor) || (!descriptor.timeoutId && !descriptor.intervalId)){
		console.warn("clearIntervalWithDelay: Incorrect descriptor. Please pass an object returned by setIntervalWithDelay. Skipping this call.")
		return
	}
	if(descriptor.timeoutId){
		clearTimeout(descriptor.timeoutId)
		descriptor.timeoutId = null
		console.log("clearIntervalWithDelay: stopped during delay.")
	}
	if(descriptor.intervalId){
		clearInterval(descriptor.intervalId)
		descriptor.intervalId = null
		console.log("clearIntervalWithDelay: stopped during interval repeat.")
	}
}

// export function msToMins(ms){
// 	if(typeof ms !== "number"){
// 		console.log("msToMins: ms is not a number: ", ms)
// 		return ms
// 	}
// 	return ms / 1000 / 60
// }
//
// export function minsToMs(mins){
// 	if(typeof mins !== "number"){
// 		console.log("minsToMs: ms is not a number: ", mins)
// 		return mins
// 	}
// 	return mins * 1000 * 60
// }

export function msToMins(ms){
	let ms2 = Number(ms)
	if(!ms || isNaN(ms2)){
		console.log("msToMins: ms is not a number: ", ms)
		return ms
	}
	return ms2 / 1000 / 60
}

export function minsToMs(mins){
	let mins2 = Number(mins)
	if(!mins || isNaN(mins2)){
		console.log("minsToMs: ms is not a number: ", mins)
		return mins
	}
	return mins2 * 1000 * 60
}

export function timeNow() {
	return Date.now()
}

export const daysAgo = (timestamp) => {
	return daysDifference(timestamp)
}
export const timeDifferenceFormatted = (timestamp) => {
	let timeDiffAmount = Math.abs(daysDifference(timestamp))
	console.log("timeDifferenceFormatted: timeDiffAmount = ", timeDiffAmount)
	let periodName = "day"
	if(timeDiffAmount >= 28){
		timeDiffAmount = Math.round(timeDiffAmount / 30)
		periodName = "month"
	}
	if(timeDiffAmount >= 12){
		timeDiffAmount = Math.floor(timeDiffAmount / 12)
		periodName = "year"
	}

	if(timeDiffAmount > 1){
		periodName += "s"
	}
	return `${timeDiffAmount} ${periodName}`
}

export const daysAgoFormatted = (timestamp, options) => {
	return daysDifferenceFormatted(timestamp, options)
}

export const dateLabelFormatted = (verb, timestamp) => {
	if(Math.abs(daysAgo()) < 2){
		return `${verb} ${daysAgoFormatted(timestamp)}`
	}
	if(Math.abs(daysAgo()) > 30){
		return `${verb} on ${daysAgoFormatted(timestamp)}`
	}

	return `${verb} on ${daysAgoFormatted(timestamp)} (${daysAgoFormatted(timestamp)})`
}


/**
 * walks a node down
 * @param vnode
 * @param cb
 */
export function walk(vnode, cb) {
	console.log("beforeLeave11 1: vnode= ", vnode)
	if (!vnode) return;
	console.log("beforeLeave11 2: vnode= ", vnode)

	if (vnode.component) {
		console.log("beforeLeave11 3: vnode= ", vnode)
		const proxy = vnode.component.proxy;
		if (proxy) {
			let res = cb(vnode.component.proxy);
			if(res){
				console.log("beforeLeave11 4: vnode= ", vnode)
				return res
			}
		}
		return walk(vnode.component.subTree, cb);
	} else if (vnode.shapeFlag & 16) {
		console.log("beforeLeave11 5: vnode= ", vnode)
		const vnodes = vnode.children;
		for (let i = 0; i < vnodes.length; i++) {
			let res = walk(vnodes[i], cb);
			if(res){
				return res
			}
		}
	}
	console.log("beforeLeave11 6: vnode= ", vnode)
}

export async function logError(error, info) {
	console.error(error)
	// console.trace(error)
	// console.log("logError CommonObject = ", CommonObject)
	try{
		let errorData = await CommonObject.dataManager.logError(error, info)
		console.log("logError errorData = : ", errorData)
		errorData.userEmail = "amended"
		await CommonObject.analyticManager.trackEvent("Error", errorData)
	} catch (error){
		console.warn(error)
	}
}

export function saveBytesToFile(bytes, fileName, mimeType) {
	const blob = new Blob([bytes], { type: mimeType });
	const url = URL.createObjectURL(blob);

	triggerDownload(url, fileName)
	// window.open(url, '_blank');
	setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export function triggerDownload(url, filename) {
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}

export function tryReloadOnChunkLoadFailed(error){
	if(!error){
		return false
	}
	let chunkErrorData = getChunkLoadErrorData(error)
	if(!chunkErrorData){
		return false
	}

	let key = `qw_chnk_${chunkErrorData.key}`
	let attempts = 0
	if(window.sessionStorage){
		attempts = Number(window.sessionStorage.getItem(key)) || 0
		window.sessionStorage.setItem(key, attempts + 1)
	}
	console.log("tryReloadOnChunkLoadFailed: key = ", key, ", attempts = ", attempts, ", error = ", error)

	if(attempts > 0){
		return true
	}

	let reloadMessage = 'A new version is available. Click "ok" to reload. WARNING: any unsaved data will be lost.'
	if(window.confirm(reloadMessage)){
		console.log("tryReloadOnChunkLoadFailed: reloading")
		window.location.reload()
	}

	return true
}

function getChunkLoadErrorData(error){
	let str = getChunkLoadErrorMessage(error)
	if(!str){
		return null
	}

	let matchers = [
		/Loading chunk ([^\s)]+) failed/i,
		/Loading CSS chunk ([^\s)]+) failed/i,
		/ChunkLoadError/i,
		/Failed to fetch dynamically imported module/i,
	]

	for(let matcher of matchers){
		let match = str.match(matcher)
		if(match){
			let key = getChunkLoadErrorKey(match[1], str)
			return {
				key,
				message: str,
			}
		}
	}

	return null
}

function getChunkLoadErrorMessage(error){
	if(error?.name === "ChunkLoadError"){
		return error.message || error.name
	}
	if(typeof error?.message === "string" && error.message){
		return error.message
	}
	if(typeof error?.reason?.message === "string" && error.reason.message){
		return error.reason.message
	}
	if(typeof error?.reason === "string" && error.reason){
		return error.reason
	}
	if(typeof error === "string"){
		return error
	}
	return ""
}

function getChunkLoadErrorKey(chunkName, message){
	let extractedUrl = extractChunkUrl(message)
	if(extractedUrl){
		return extractedUrl
	}
	if(chunkName){
		return chunkName
	}
	return message
}

function extractChunkUrl(message){
	let urlMatch = message.match(/https?:\/\/[^\s)]+/i)
	if(!urlMatch){
		return ""
	}
	let url = urlMatch[0]
	let urlParts = url.split("/")
	return urlParts[urlParts.length - 1] || url
}

export function mergeArraysBySum(array1, array2){
	let res = []
	let length = Math.max(array1.length, array2.length)
	for(let i = 0; i < length; i++){
		let val1 = array1[i] || 0
		let val2 = array2[i] || 0
		res.push(val1 + val2)
	}
	return res
}

export function evaluateFormFormula(scoreFormula){
	try{
		return eval(scoreFormula)
	} catch (error) {
		console.error(error)
		return null
	}
}

// export function getClassConstructorByName(name,...a) {
// 	let c = eval(name);
// 	return c//new c(...a);
// }

export function getClassName(obj){
	return obj.constructor.name
}

export function mapObject(obj, callback) {
	return Object.keys(obj).reduce((result, key) => {
		result[key] = callback(obj[key], key)
		return result
	}, {})
}

export function mapObjectToValues(obj) {
	return mapObject(obj, value => value.value)
}



export function arrayToTruthyObject(array){
	return Array.isArray(array) ? array.reduce((obj, value) => ({...obj, [value]: true}), {}) : array
}

export function debounceMergeArgs(func, wait, mergeFunc = (args) => args) {
	let timeout;
	let args = [];

	return function(...newArgs) {
		// Collect arguments from each call using the merge function
		args = mergeFunc(args, newArgs);

		// Clear the existing timeout
		clearTimeout(timeout);

		// Set a new timeout
		timeout = setTimeout(() => {
			// Call the function with the collected arguments
			func(...args);
			// Clear the arguments after the function is called
			args = [];
		}, wait);
	};
}

//px to rem
export function pxToRem(px) {
	return `${px / 16}rem`
}


export function asSingleElement(array) {
	if(Array.isArray(array)){
		return array.length ? array[0] : null
	}
	return array
}

export function ensureArray(value) {
	return asArray(value)
}

export function asArray(value) {
	if(!Array.isArray(value)){
		return value ? [value] : []
	}
	return value
}

export function createPathKey(...keys){
	return keys.join("+")
}
export function getInheritShareKey(...keys){
	return ["inherit", ...keys].join("+")
}
export function getClearanceAllowKey(...keys){
	return ["clearance-allow", ...keys].join("+")
}
//getIndexKeyAnd only needed until firebase starts to support array-contains-all
export function getIndexKeyAnd(...keys){
	return keys.join("_")
}
